export default __webpack_public_path__ + "static/media/ASPA_PARTNER_FOCUS_7.af606045.png";